// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffcommon/v1/eex_service.proto (package bffcommon.v1, syntax proto3)
/* eslint-disable */

import { EEXService } from "./eex_service_pb";

/**
 * @generated from rpc bffcommon.v1.EEXService.ListContracts
 */
export const listContracts = EEXService.method.listContracts;
